export function imageIdToNumber(id?: string): number {
  return id ? parseInt(id.replace(/\D/g, '').substring(0, 3)) : 0;
}
